export const wxNavigate = url => {
  console.log('wx url: ', url)
  if (url) {
    window.wx.miniProgram.navigateTo({
      url // 这里是小程序页面
    })
  }
}
